import { ApiService } from './api';
import { ApiResponse } from '../types/auth';

export interface UploadedFileResponse {
  id: string;
}

export class UploadService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async uploadImage(file: File): Promise<ApiResponse<UploadedFileResponse>> {
    try {
      const response = await this.apiService.uploadFile<UploadedFileResponse>(
        '/upload/image',
        file
      );

      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to upload image',
        success: false
      };
    }
  }
}

export const uploadService = new UploadService();
